// Legacy import path used across the app.
// Re-export the single i18next instance configured in `src/i18n.js`.
import i18n from "../i18n"

export default i18n
